export default __webpack_public_path__ + "static/media/NABH-new.4d130d12.png";